import { Button } from '@app/components/common/buttons/Button/Button';
import { Select } from '@app/components/common/selects/Select/Select';
import { Table } from '@app/components/common/Table/Table';
import { media } from '@app/styles/themes/constants';
import { SearchInput } from 'components/common/inputs/SearchInput/SearchInput';
import styled from 'styled-components';

export const TablesWrapper = styled.div`
  margin-top: 1.875rem;
`;

export const InputSearch = styled(SearchInput)`
  .ant-input-group-addon {
    display: none;
  }

  @media only screen and ${media.md} {
    .ant-input-group .ant-input-affix-wrapper:not(:last-child) {
      border-radius: 3.125rem;
      border: 0;
      padding: 0.5625rem 1.25rem;
    }
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;

  a,
  div {
    &:nth-child(2) {
      padding-top: 0.625rem;
      border-top: 1px solid var(--border-color);
    }
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;

  .ant-select {
    min-width: 12rem;
    max-width: 12rem;

    &.multiselect {
      min-width: 14rem;
      max-width: 25rem;
    }
  }

  @media (max-width: 768px) {
    justify-content: flex-start;
    gap: 10px;

    .ant-select {
      min-width: 8rem;
      max-width: 11rem;
      width: 50%;
    }
  }

  @media (max-width: 420px) {
    .ant-select {
      min-width: 8rem;
      max-width: 10rem;
      width: 50%;
    }
  }

  @media (max-width: 400px) {
    .ant-select {
      min-width: 8rem;
      max-width: 9rem;
      width: 50%;
    }
  }
`;

export const TableActionWrapper = styled.div`
  margin-bottom: 2rem;
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  &.flex-start {
    justify-content: flex-start;
  }

  .add-btn {
    width: 9rem;
  }

  &.width-100 {
    width: 100%;
  }

  .width-auto {
    width: auto;
  }

  .hover-button:hover {
    background-color: var(--primary-color);
    color: #fff;
    border-color: var(--primary-color);
  }

  .ant-input-group-wrapper {
    width: 8rem;
  }

  .font-sm {
    font-size: 14px;
    padding: 10px;
  }

  &.between {
    justify-content: space-between;
    width: 100%;
  }

  @media (max-width: 768px) {
    gap: 10px;

    .ant-btn.ant-btn-primary {
      font-size: 13px;
      width: 100%;
      max-width: max-content;
      height: 58px;
    }

    .ant-input-group-wrapper {
      width: 100%;
      max-width: calc(100% - 100px);
    }
  }

  @media only screen and ${media.sm} {
    .ant-input-group-wrapper {
      width: 10rem;
    }
  }

  @media only screen and ${media.md} {
    .ant-input-group-wrapper {
      width: 12rem;
    }
  }

  @media only screen and ${media.lg} {
    .ant-input-group-wrapper {
      width: 15rem;
    }
  }
`;

export const ScrollTable = styled(Table)`
  height: 400px;
  overflow: auto;
`;

export const Btn = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;

  &.mb-2 {
    margin-bottom: 2rem;
  }
`;

export const Title = styled.label`
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--primary-color);
  display: block;
`;

export const Label = styled.label`
  margin-right: 0.625rem;
`;

export const SelectOpn = styled(Select)`
  width: 100%;
  max-width: 15rem;
  min-width: 15rem;
`;

export const ActionButton = styled.button`
  background-color: transparent !important;
  border: none;
  padding: 0 !important;
  cursor: pointer !important;
  font-size: 25px;
  width: 23px;
  height: 23px;
  font-weight: bold;
  display: flex;
  align-items: center;

  &:hover {
    color: #1cccb2 !important;
  }

  @media (max-width: 768px) {
    width: 19px;
    height: 22px;
  }
`;

export const NameColumn = styled.a`
  color: #01509a;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;

  @media (max-width: 768px) {
    max-width: 85px;
    text-overflow: ellipsis;
    white-space: break-spaces;
    display: block;
  }
`;
